var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 862,
    height: 397,
    viewBox: "0 0 862 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.87 0.373405C657.297 0.373405 832.83 156.532 860.155 382.066C860.742 386.914 861.71 396.705 861.71 396.705L650.352 396.704C650.352 396.704 649.439 391.146 648.925 388.413C626.527 269.351 532.096 209.263 430.87 209.263C330.802 209.263 237.374 267.985 213.612 384.352C212.786 388.4 211.388 396.704 211.388 396.704L0.0302734 396.705C0.0302734 396.705 1.43102 382.96 2.33454 376.182C31.976 153.82 206.418 0.373405 430.87 0.373405Z",
    fill: "url(#paint0_linear_4_4373)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_4373",
    x1: 686.797,
    y1: 0.373438,
    x2: 315.613,
    y2: 448.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E65A2",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67578B",
    stopOpacity: 0.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.0eaad5d7c9a6553a86df8153971e3077.svg";
export { ForwardRef as ReactComponent };